// codici FatturaPA proposti nel pannello Aruba (gli stessi che il backend offre nella pagina Crea fattura)
export const OPZIONI_FATTURA = {
	regimi: [
		{ code: 'RF01', text: 'RF01 - Ordinario' },
		{ code: 'RF02', text: 'RF02 - Contribuenti minimi' },
		{ code: 'RF19', text: 'RF19 - Forfettario' },
		{ code: 'RF04', text: 'RF04 - Agricoltura e pesca' },
		{ code: 'RF10', text: 'RF10 - Spettacoli e intrattenimenti' },
		{ code: 'RF18', text: 'RF18 - Altro' },
	],
	nature: [
		{ code: 'N1', text: 'N1 - Escluse ex art. 15' },
		{ code: 'N2.1', text: 'N2.1 - Non soggette (artt. 7-7septies)' },
		{ code: 'N2.2', text: 'N2.2 - Non soggette, altri casi' },
		{ code: 'N3.1', text: 'N3.1 - Non imponibili, esportazioni' },
		{ code: 'N3.2', text: 'N3.2 - Non imponibili, cessioni intracomunitarie' },
		{ code: 'N3.5', text: "N3.5 - Non imponibili, dichiarazione d'intento" },
		{ code: 'N3.6', text: 'N3.6 - Non imponibili, altre operazioni' },
		{ code: 'N4', text: 'N4 - Esenti' },
		{ code: 'N5', text: 'N5 - Regime del margine' },
		{ code: 'N7', text: 'N7 - IVA assolta in altro stato UE (OSS)' },
	],
	modalita: [
		{ code: 'MP01', text: 'MP01 - Contanti' },
		{ code: 'MP02', text: 'MP02 - Assegno' },
		{ code: 'MP05', text: 'MP05 - Bonifico' },
		{ code: 'MP08', text: 'MP08 - Carta di pagamento' },
		{ code: 'MP12', text: 'MP12 - RIBA' },
		{ code: 'MP19', text: 'MP19 - SEPA Direct Debit' },
		{ code: 'MP23', text: 'MP23 - PagoPA' },
	],
};
